import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "viewHead",
  id: "agg-map-view"
}
const _hoisted_2 = { class: "align-top" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Aggregate View")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "aggregate sentence-level attention patterns for this attention head", -1)
const _hoisted_5 = { class: "attn-btns" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("hide")
const _hoisted_7 = ["id"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { id: "vis" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _hoisted_3,
        _createVNode(_component_a_tooltip, { placement: "bottom" }, {
          title: _withCtx(() => [
            _hoisted_4
          ]),
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              icon: "info",
              class: "info-icon"
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_button, {
          id: "hide-agg",
          class: "clear",
          type: "link",
          onClick: $setup.hideShowAgg
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          id: $props.myID,
          class: "bertviz"
        }, _hoisted_9, 8, _hoisted_7)
      ]),
      _: 1
    })
  ]))
}